module.exports = __webpack_public_path__ + "img/staff-1997-group.40bd8573.jpg";